import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  IoHomeOutline,
  IoSettingsOutline,
  IoWalletOutline,
  IoStorefrontOutline,
  IoWarningOutline,
  IoShieldCheckmarkOutline,
  IoBriefcaseOutline,
  IoListCircleOutline,
  IoChatbubblesOutline,
  IoMegaphoneOutline,
  IoBusinessOutline,
  IoCalendarOutline,
  IoDocumentTextOutline,
  IoBarChartOutline,
  IoCarSportOutline,
  IoArchiveOutline,
  IoTimerOutline,
  IoCheckboxOutline,
  IoTrendingUpOutline,
  IoLockOpenOutline,
  IoPeopleOutline
} from 'react-icons/io5';
import BotonPanico from '../Safety/BotonPanico';
import './KondoBottomNav.css';

const KondoBottomNav = ({ activeRoute }) => {
  const navigate = useNavigate();
  const { userData, isMoroso } = useAuth();

  if (!userData) return null;

  const rol = userData.rol;
  // const isGlobal = userData.condominioId === 'GLOBAL' || !userData.condominioId;

  const isActive = (route) => activeRoute === route ? 'ks-nav-item active' : 'ks-nav-item';

  // 1. MASTER USER / SUPERUSER
  if (rol === 'masteruser' || (rol === 'superuser' && (!userData.condominioId || userData.condominioId === 'GLOBAL'))) {
    return (
      <nav className="ks-bottom-nav-island">
        <button className={isActive('/app')} onClick={() => navigate('/app')}>
          <IoHomeOutline size={22} />
          <span>Inicio</span>
        </button>
        <button className={isActive('/superuser/validacion-proveedores')} onClick={() => navigate('/superuser/validacion-proveedores')}>
          <IoShieldCheckmarkOutline size={22} />
          <span>Validación</span>
        </button>
        <button className={isActive('/superuser/master-portal')} onClick={() => navigate('/superuser/master-portal')}>
          <IoBriefcaseOutline size={22} />
          <span>Portal</span>
        </button>
        <button className={isActive('/superuser/crm')} onClick={() => navigate('/superuser/crm')}>
          <IoPeopleOutline size={22} />
          <span>CRM</span>
        </button>
        <button className={isActive('/superuser/analytics')} onClick={() => navigate('/superuser/analytics')}>
          <IoBarChartOutline size={22} />
          <span>Analytics</span>
        </button>
      </nav>
    );
  }

  // 2. ADMIN DE CONDOMINIO
  if (rol === 'admin' || rol === 'comite' || (rol === 'masteruser' && userData.condominioId && userData.condominioId !== 'GLOBAL')) {
    return (
      <nav className="ks-bottom-nav-island">
        <button className={isActive('/')} onClick={() => navigate('/')}>
          <IoHomeOutline size={22} />
          <span>Inicio</span>
        </button>
        <button className={isActive('/admin/muro')} onClick={() => navigate('/admin/muro')}>
          <IoChatbubblesOutline size={22} />
          <span>Muro</span>
        </button>
        <button className={isActive('/gestion-avisos')} onClick={() => navigate('/gestion-avisos')}>
          <IoMegaphoneOutline size={22} />
          <span>Avisos</span>
        </button>
        <button className={isActive('/gestion-reportes')} onClick={() => navigate('/gestion-reportes')}>
          <IoWarningOutline size={22} />
          <span>Reportes</span>
        </button>
        <button className={isActive('/admin/accesos')} onClick={() => navigate('/admin/accesos')}>
          <IoLockOpenOutline size={22} />
          <span>Accesos</span>
        </button>
      </nav>
    );
  }

  // 3. PROVEEDOR EXTERNO MARKETPLACE
  if (rol === 'proveedor') {
    return (
      <nav className="ks-bottom-nav-island">
        <button className={isActive('/')} onClick={() => navigate('/')}>
          <IoHomeOutline size={22} />
          <span>Inicio</span>
        </button>
        <button className={isActive('/proveedor/servicios')} onClick={() => navigate('/proveedor/servicios')}>
          <IoBriefcaseOutline size={22} />
          <span>Servicios</span>
        </button>
        <button className={isActive('/proveedor/cotizaciones')} onClick={() => navigate('/proveedor/cotizaciones')}>
          <IoDocumentTextOutline size={22} />
          <span>Cotizaciones</span>
        </button>
        <button className={isActive('/proveedor/calendario')} onClick={() => navigate('/proveedor/calendario')}>
          <IoCalendarOutline size={22} />
          <span>Calendario</span>
        </button>
        <button className={isActive('/perfil')} onClick={() => navigate('/perfil')}>
          <IoSettingsOutline size={22} />
          <span>Perfil</span>
        </button>
      </nav>
    );
  }

  // 4.5 TRABAJADOR
  if (rol === 'trabajador') {
    return (
      <nav className="ks-bottom-nav-island" style={{ gridTemplateColumns: 'repeat(5, 1fr)' }}>
        <button className={isActive('/')} onClick={() => navigate('/')}>
          <IoHomeOutline size={22} />
          <span>Inicio</span>
        </button>
        <button className={isActive('/trabajador/asistencia')} onClick={() => navigate('/trabajador/asistencia')}>
          <IoTimerOutline size={22} />
          <span>Asistencia</span>
        </button>
        <button className={isActive('/trabajador/actividades')} onClick={() => navigate('/trabajador/actividades')}>
          <IoCheckboxOutline size={22} />
          <span>Tareas</span>
        </button>
        <button className={isActive('/trabajador/nomina')} onClick={() => navigate('/trabajador/nomina')}>
          <IoWalletOutline size={22} />
          <span>Nómina</span>
        </button>
        <button className={isActive('/trabajador/metas')} onClick={() => navigate('/trabajador/metas')}>
          <IoTrendingUpOutline size={22} />
          <span>Metas</span>
        </button>
      </nav>
    );
  }

  // 4. VIGILANTE
  if (rol === 'vigilante') {
    return (
      <nav className="ks-bottom-nav-island" style={{ gridTemplateColumns: 'repeat(5, 1fr)' }}>
        <button className={isActive('/')} onClick={() => navigate('/')}>
          <IoHomeOutline size={22} />
          <span>Inicio</span>
        </button>
        <button className={isActive('/estacionamientos')} onClick={() => navigate('/estacionamientos')}>
          <IoCarSportOutline size={22} />
          <span>Estacionamientos</span>
        </button>
        <button className={isActive('/seguridad')} onClick={() => navigate('/seguridad')}>
          <IoShieldCheckmarkOutline size={22} />
          <span>Seguridad</span>
        </button>
        <button className={isActive('/paqueteria')} onClick={() => navigate('/paqueteria')}>
          <IoArchiveOutline size={22} />
          <span>Lockers</span>
        </button>
        <button className={isActive('/proveedores-generales')} onClick={() => navigate('/proveedores-generales')}>
          <IoBusinessOutline size={22} />
          <span>Proveedores</span>
        </button>
      </nav>
    );
  }

  // 5. RESIDENTE Y OTROS Default Behavior
  return (
    <nav className="ks-bottom-nav-island">
      <button className={isActive('/')} onClick={() => navigate('/')}>
        <IoHomeOutline size={22} />
        <span>Inicio</span>
      </button>

      <button className={isActive('/marketplace')} onClick={() => navigate('/marketplace')}>
        <IoStorefrontOutline size={22} />
        <span>Marketplace</span>
      </button>

      {/* SOS Center */}
      <div className="ks-sos-wrapper">
        {userData?.condominioId && userData.condominioId !== 'GLOBAL' && ['residente'].includes(userData?.rol) ? (
          <BotonPanico />
        ) : (
          <button className="ks-sos-btn-placeholder" onClick={() => navigate('/seguridad')}>
            <IoWarningOutline size={26} />
          </button>
        )}
      </div>

      <button className={isActive('/pagar-cuota')} onClick={() => navigate('/pagar-cuota')}>
        <IoWalletOutline size={22} />
        <span>Pagar Cuota</span>
      </button>

      <button className={isActive('/perfil')} onClick={() => navigate('/perfil')}>
        <IoSettingsOutline size={22} />
        <span>Perfil</span>
      </button>
    </nav>
  );
};

export default KondoBottomNav;
